import { APPLICANT_FIELD_NAME } from '../constants/fieldNames';
import { serializePhoneValue } from '../constants/REGEXP_PATTERNS';
import { CITIZENSHIP } from '../constants/citizenship';
import { i18n } from '../helpers/i18n';
import { t } from '@lingui/macro';

const applicantSerializer = (data) => {
  const {
    name,
    surname,
    patronymic,
    phone,
    email,
    sex,
    isPatronymicAbsent,
    birthdate,
    snils,
    birthPlace,
  } = APPLICANT_FIELD_NAME;

  /* eslint-disable camelcase */
  const {
    status,
    person,
    registration_data: registrationData,
    snils: { snils_number: snilsNumber },
    passport_rf: passport,
  } = data;
  /* eslint-enable camelcase */

  const {
    name: nameVal = '',
    surname: surnameVal = '',
    patronymic: patronymicVal = '',
  } = status;
  const { gender: sexVal = '', birthdate: birthdateVal = '' } = person;
  const { phone_mp: elkPhone, email: emailVal = '' } = registrationData;

  const phoneVal = elkPhone ? serializePhoneValue(elkPhone) : '';
  const noPatronymic = i18n._(t`Нет отчества`);

  const { number, birth_place: birthPlaceVal = '' } = passport;
  const disableDul = !!number;

  return {
    [name]: {
      value: nameVal,
      disabled: !!nameVal,
    },
    [surname]: {
      value: surnameVal,
      disabled: !!surnameVal,
    },
    [patronymic]: {
      value: patronymicVal || noPatronymic,
      disabled: true,
    },
    [isPatronymicAbsent]: { value: !patronymicVal },
    [birthdate]: {
      value: birthdateVal,
      disabled: !!birthdateVal,
    },
    [phone]: {
      value: phoneVal,
      disabled: !!phoneVal,
    },
    [email]: {
      value: emailVal,
      disabled: !!emailVal,
    },
    [sex]: {
      value: sexVal,
      disabled: !!sexVal,
    },
    [snils]: {
      value: snilsNumber,
    },
    citizenship: {
      value: disableDul ? CITIZENSHIP.CITIZEN : null,
    },
    [birthPlace]: {
      value: birthPlaceVal,
      disabled: !!birthPlaceVal,
    },
  };
};

export default applicantSerializer;
